import React from 'react';

// LOCAL COMPONENTS
import ConfirmationModal from './ConfirmationModal';

// MAIN COMPONENT
const ErrorModal = ({
  message,
  errors,
  continueButton = {},
  ...props
}) => (
  <ConfirmationModal
    {...props}
    title="Error"
    body={<>
      <p>{message}</p>
      {errors?.length &&
        <ul className="ps-3 text-start">
          {errors.map(error => (
            <li>{error}</li>
          ))}
        </ul>
      }
    </>}
    cancelButton={false}
    continueButton={{
      label: 'OK',
      ...continueButton
    }}
  />
)

// EXPORT
export default ErrorModal;
